{
  "completed": "Завершено: ",
  "current": "Поточний: ",
  "notCompleted": "Не завершено: ",
  "steplist": "Список кроків"
}
